import React, { useState, useEffect } from "react";
import { Form, Input, Select, Switch, Tooltip, } from 'antd';
import { FormattedMessage, useIntl, } from "react-intl";
import { Controller, } from "react-hook-form";
import { InfoIcon, } from "@phosphor-icons/react";

const UserFormView = ({
    control,
    history,
    formMode,
    userGroups,
    ...props
}) => {

    const [permission, setPermission] = useState("users");
    const { locale, } = props;
    const intl = useIntl();

    useEffect(() => {
        if ("authentication" in sessionStorage) {
            const localdata = sessionStorage.getItem('authentication');
            const idToken = JSON.parse(localdata);
            if ("permission" in idToken) {
                setPermission(idToken.permission);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const filterOption = (input, option) => {
        return option.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
            option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };

    return (

        <Form
            labelCol={{ span: 10 }}
            wrapperCol={{ span: 14 }}>

            {/* Contact person (first & last name) */}
            <Form.Item
                label={<strong><FormattedMessage id="firstname-and-lastname" /></strong>}
                required
                style={{ marginBottom: 0 }}>

                {/* First name */}
                <FormattedMessage id="first-name">
                    {NameField =>
                        <Controller
                            control={control}
                            defaultValue=""
                            name="user_first_name"
                            rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                            render={({
                                field: { onChange, onBlur, value, name, ref },
                                fieldState: { error },
                            }) => (
                                <Form.Item
                                    help={error && intl.formatMessage({ id: error?.message })}
                                    hasFeedback
                                    validateStatus={error?.message && "error"}
                                    required
                                    style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                                // label={<FormattedMessage id="firstname-and-lastname" />}
                                >
                                    <Input
                                        ref={ref}
                                        placeholder={NameField}
                                        onChange={onChange}
                                        value={value}
                                    />
                                </Form.Item>
                            )}
                        />
                    }
                </FormattedMessage>

                {/* last name */}
                <FormattedMessage id="last-name">
                    {NameField =>
                        <Controller
                            control={control}
                            defaultValue=""
                            name="user_last_name"
                            rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                            render={({
                                field: { onChange, onBlur, value, name, ref },
                                fieldState: { error },
                            }) => (
                                <Form.Item
                                    help={error && intl.formatMessage({ id: error?.message })}
                                    hasFeedback
                                    validateStatus={error?.message && "error"}
                                    required
                                    style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}>
                                    <Input
                                        ref={ref}
                                        placeholder={NameField}
                                        onChange={onChange}
                                        value={value}
                                    />
                                </Form.Item>
                            )}
                        />
                    }
                </FormattedMessage>
            </Form.Item>

            {/* email address */}
            <FormattedMessage id="emailaddress">
                {NameField =>
                    <Controller
                        control={control}
                        defaultValue=""
                        name="user_email"
                        rules={{
                            required: { value: true, message: "inputfield-FieldIsRequired" },
                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i,
                                message: "EmailAddressNotValid",
                            },
                            // validate: {
                            //     checkemail: async (value) => {
                            //         if (!value) { return true };
                            //         return await checkEmail(value, schoolID).then(response => {
                            //             if (response.exists) { return 'EmailAddressAlreadyExist' };
                            //         });
                            //     },
                            //     checkemailfrontend: (value) => { return checkEmailAlreadyUsed(value) }
                            // },
                        }}
                        render={({
                            field: { onChange, onBlur, value, name, ref },
                            fieldState: { error },
                        }) => (
                            <Form.Item
                                help={error && intl.formatMessage({ id: error?.message })}
                                hasFeedback
                                validateStatus={error?.message && "error"}
                                required
                                label={<strong><FormattedMessage id="emailaddress" /></strong>}>
                                <Input
                                    ref={ref}
                                    disabled={formMode === 'edit'}
                                    placeholder={NameField}
                                    onChange={onChange}
                                    value={value}
                                />
                            </Form.Item>
                        )}
                    />
                }
            </FormattedMessage>

            {/* phone number */}
            <FormattedMessage id="phonenumber">
                {NameField =>
                    <Controller
                        control={control}
                        defaultValue=""
                        name="user_phone_number"
                        rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                        render={({
                            field: { onChange, onBlur, value, name, ref },
                            fieldState: { error },
                        }) => (
                            <Form.Item
                                help={error && intl.formatMessage({ id: error?.message })}
                                hasFeedback
                                validateStatus={error?.message && "error"}
                                required
                                label={<strong>{NameField}</strong>}>
                                <Input
                                    ref={ref}
                                    placeholder={NameField}
                                    onChange={onChange}
                                    value={value}
                                />
                            </Form.Item>
                        )}
                    />
                }
            </FormattedMessage>

            {/* User permission group */}
            {permission !== "users" && (
                <FormattedMessage id="permission-group">
                    {NameField =>
                        <Controller
                            control={control}
                            // defaultValue=""
                            name="user_group"
                            rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                            render={({
                                field: { onChange, onBlur, value, name, ref },
                                fieldState: { error },
                            }) => (
                                <Form.Item
                                    help={error && intl.formatMessage({ id: error?.message })}
                                    hasFeedback
                                    validateStatus={error?.message && "error"}
                                    label={<strong>{NameField}</strong>}
                                    required>
                                    <Select
                                        showSearch
                                        filterOption={filterOption}
                                        ref={ref}
                                        options={userGroups?.sort((a, b) => a.label.localeCompare(b.label))}
                                        value={value}
                                        onChange={(e) => { onChange(e) }}
                                        placeholder={<FormattedMessage id="make-choice" />} />
                                </Form.Item>
                            )}
                        />}
                </FormattedMessage>
            )}

            {/* language settings */}
            <FormattedMessage id="display-language">
                {NameField =>
                    <Controller
                        control={control}
                        defaultValue={locale}
                        name="user_language"
                        rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                        render={({
                            field: { onChange, onBlur, value, name, ref },
                            fieldState: { error },
                        }) => (
                            <Form.Item
                                help={error && intl.formatMessage({ id: error?.message })}
                                hasFeedback
                                validateStatus={error?.message && "error"}
                                required
                                label={<strong>{NameField}</strong>}>
                                <Select
                                    ref={ref}
                                    placeholder={NameField}
                                    onChange={onChange}
                                    value={value}>
                                    <Select.Option key="" value=""><FormattedMessage id="make-choice" /></Select.Option>
                                    <Select.Option key="nl" value="nl"><FormattedMessage id="dutch" /></Select.Option>
                                    <Select.Option key="en" value="en"><FormattedMessage id="english" /></Select.Option>
                                    <Select.Option key="de" value="de"><FormattedMessage id="german" /></Select.Option>
                                </Select>
                            </Form.Item>
                        )}
                    />
                }
            </FormattedMessage>

            {/* user note card */}
            {permission !== "users" && (
                <FormattedMessage id="user-notes">
                    {NameField =>
                        <Controller
                            control={control}
                            defaultValue=""
                            name="user_note"
                            rules={{
                                // required: { value: true, message: "inputfield-FieldIsRequired" }
                            }}
                            render={({
                                field: { onChange, onBlur, value, name, ref },
                                fieldState: { error },
                            }) => (
                                <Form.Item
                                    help={error && intl.formatMessage({ id: error?.message })}
                                    hasFeedback
                                    validateStatus={error?.message && "error"}
                                    label={<strong>{NameField}</strong>}>
                                    <Input.TextArea
                                        ref={ref}
                                        placeholder={NameField}
                                        onChange={onChange}
                                        value={value}
                                    />
                                </Form.Item>
                            )}
                        />
                    }
                </FormattedMessage>
            )}

            {/* user_ip_validation_disabled settings */}
            {permission === "administrators" && (
                <FormattedMessage id="disable-location-validation">
                    {NameField =>
                        <Controller
                            control={control}
                            defaultValue={false}
                            name="user_ip_validation_disabled"
                            // rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                            render={({
                                field: { onChange, onBlur, value, name, ref },
                                fieldState: { error },
                            }) => (
                                <Form.Item
                                    // help={error && intl.formatMessage({ id: error?.message })}
                                    // hasFeedback
                                    // validateStatus={error?.message && "error"}
                                    // required
                                    label={<strong>{NameField}</strong>}>
                                    <Switch
                                        ref={ref}
                                        onChange={onChange}
                                        value={value} />
                                    <small className="form-text text-muted float-end">
                                        <Tooltip title={<FormattedMessage id="disable-location-validation-tt" />}>
                                            <InfoIcon size={18} weight="light" />
                                        </Tooltip>
                                    </small>

                                </Form.Item>
                            )}
                        />
                    }
                </FormattedMessage>
            )}

            <FormattedMessage id="disable-location-validation">
                {NameField =>
                    <Controller
                        control={control}
                        defaultValue={false}
                        name="user_ip_validation_disabled"
                        // rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                        render={({
                            field: { onChange, onBlur, value, name, ref },
                            fieldState: { error },
                        }) => (
                            <Form.Item
                                // help={error && intl.formatMessage({ id: error?.message })}
                                // hasFeedback
                                // validateStatus={error?.message && "error"}
                                // required
                                label={<strong>{NameField}</strong>}>
                                <Switch
                                    ref={ref}
                                    onChange={onChange}
                                    value={value} />
                                <small className="form-text text-muted float-end">
                                    <Tooltip title={<FormattedMessage id="disable-location-validation-tt" />}>
                                        <InfoIcon size={18} weight="light" />
                                    </Tooltip>
                                </small>

                            </Form.Item>
                        )}
                    />
                }
            </FormattedMessage>

        </Form>
    );
};

export default UserFormView;
